import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "hidden", "results", "selected"]
  static values = {
    url: String,
    minLength: { type: Number, default: 2 }
  }

  connect() {
    this.hideResults()
  }

  disconnect() {
    this.hideResults()
  }

  search() {
    const query = this.inputTarget.value.trim()
    if (query.length < this.minLengthValue) {
      this.hideResults()
      return
    }
    this.fetchResults(query)
  }

  async fetchResults(query) {
    try {
      const response = await fetch(`${this.urlValue}?q=${encodeURIComponent(query)}`, {
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      if (!response.ok) throw new Error('検索に失敗しました')
      const data = await response.json()
      this.displayResults(Array.isArray(data) ? data : [])
    } catch (error) {
      console.error('Search error:', error)
      this.resultsTarget.innerHTML = '<div class="customer-search-item text-danger text-center">検索中にエラーが発生しました</div>'
      this.showResults()
    }
  }

  displayResults(items) {
    if (!items || items.length === 0) {
      this.resultsTarget.innerHTML = `
        <div class="customer-search-item text-muted text-center">
          該当するユーザーが見つかりません
        </div>`
    } else {
      this.resultsTarget.innerHTML = items.map(item => `
        <div class="customer-search-item"
             data-action="click->autocomplete#select"
             data-id="${item.id}"
             data-name="${this.escapeHtml(item.name)}">
          <div class="customer-name">${this.escapeHtml(item.name)}</div>
          <div class="customer-detail">残セッション: ${item.available_sessions}回</div>
        </div>
      `).join('')
    }
    this.showResults()
  }

  select(event) {
    event.preventDefault()
    const button = event.currentTarget
    const id = button.dataset.id
    const name = button.dataset.name

    this.hiddenTarget.value = id
    this.inputTarget.value = name

    if (this.hasSelectedTarget) {
      this.selectedTarget.innerHTML = `
        <div class="alert alert-info d-flex justify-content-between align-items-center mb-0">
          <span>
            <i class="bi bi-check-circle me-2"></i>
            選択中: <strong>${this.escapeHtml(name)}</strong>
          </span>
          <button type="button" class="btn-close btn-sm" data-action="click->autocomplete#clearSelection"></button>
        </div>
      `
    }

    this.hideResults()
    this.dispatch("selected", { detail: { id, name } })
  }

  clearSelection(event) {
    event.preventDefault()
    this.hiddenTarget.value = ''
    this.inputTarget.value = ''
    if (this.hasSelectedTarget) {
      this.selectedTarget.innerHTML = ''
    }
    this.inputTarget.focus()
  }

  showResults() {
    this.resultsTarget.classList.add('show')
    this.resultsTarget.style.display = 'block'
    this._boundClickOutside = this._boundClickOutside || this.clickOutside.bind(this)
    document.addEventListener('click', this._boundClickOutside)
  }

  hideResults() {
    this.resultsTarget.classList.remove('show')
    this.resultsTarget.style.display = 'none'
    if (this._boundClickOutside) {
      document.removeEventListener('click', this._boundClickOutside)
    }
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hideResults()
    }
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}
